module.exports = function (guid) {
    $.ajax({
        type: "POST",
        url: laroute.route('public::cart::ajax::add', {guid: guid})
    }).done(function( msg ) {
        if(!msg.error)
        {
            $('#add-to-cart-' + guid).remove();
            $.sticky('<b>'+msg.track+'</b><br />'+msg.message, {autoclose : 3000, position: 'top-right', type: 'st-success' });
        }else{
            $.sticky('<b>'+msg.track+'</b><br />'+msg.message, {autoclose : 3000, position: 'top-right', type: 'st-error' });
        }
    });
}
